// extracted by mini-css-extract-plugin
export default {"content":"GetStarted_content__cL5j7","buttonWrapper":"GetStarted_buttonWrapper__uq+NF"};